import React, { useState, useEffect } from 'react';
import { Alert, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useCreditStatus } from '../../hooks/useCreditStatus';
import { useAnalytics } from '../../hooks/useAnalytics';

const DISMISS_KEY_PREFIX = 'janus-credit-alert-dismissed-';

const CreditAlertBanner: React.FC = () => {
  const { t } = useTranslation();
  const { creditStatus } = useCreditStatus();
  const { trackEvent } = useAnalytics();
  const [dismissed, setDismissed] = useState(false);

  const alertLevel = creditStatus?.alertLevel;

  useEffect(() => {
    if (alertLevel && alertLevel !== 'ok') {
      const key = `${DISMISS_KEY_PREFIX}${alertLevel}`;
      setDismissed(localStorage.getItem(key) === 'true');
    }
  }, [alertLevel]);

  if (!creditStatus || alertLevel === 'ok' || dismissed) {
    return null;
  }

  const handleDismiss = () => {
    const key = `${DISMISS_KEY_PREFIX}${alertLevel}`;
    localStorage.setItem(key, 'true');
    setDismissed(true);
  };

  const isWarning = alertLevel === 'warning';
  const alertMessage = isWarning
    ? t('credits.lowBalance', { count: creditStatus.currentCredits })
    : t('credits.almostEmpty', { count: creditStatus.currentCredits });

  return (
    <Alert
      type={isWarning ? 'warning' : 'error'}
      showIcon
      closable
      onClose={handleDismiss}
      message={
        <span>
          {alertMessage}{' '}
          <Button
            type="link"
            size="small"
            href={creditStatus.rechargeUrl}
            style={{ padding: 0 }}
            onClick={() => trackEvent('credits_recharge_clicked', {
              alert_level: alertLevel,
              credits_remaining: creditStatus.currentCredits,
            })}
          >
            {t('credits.rechargeNow')}
          </Button>
        </span>
      }
      style={{ borderRadius: 0 }}
    />
  );
};

export default CreditAlertBanner;
